import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState: {
    value: null,
  },
  reducers: {
    updateUserInfo: (state: any, action: PayloadAction<App.IUserInfo | null>) => {
      state.value = action.payload;
    },
  },
});

export const { updateUserInfo } = userInfoSlice.actions;

export default userInfoSlice.reducer;
